"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var ReactDOM = require("react-dom");
var list_option_1 = require("./list-option");
var CustomPropTypes = require("../util/custom-prop-types");
var classnames_1 = require("../util/classnames");
var _1 = require("../util/_");
var warning_1 = require("../util/warning");
var data_helpers_1 = require("../util/data-helpers");
var widget_helpers_1 = require("../util/widget-helpers");
var interaction_1 = require("../util/interaction");
var vdl_prefix_1 = require("../util/vdl-prefix");
var matcher_1 = require("./matcher");
var localizers_1 = require("../util/localizers");
var optionId = function (id, idx) { return id + "__option__" + idx; };
var EMPTY_VALUE = {};
var isDisabledOrReadonly = function (item, props) { return interaction_1.isDisabledItem(item, props) || interaction_1.isReadOnlyItem(item, props); };
var ListGroupable = /** @class */ (function (_super) {
    __extends(ListGroupable, _super);
    function ListGroupable(props) {
        var _this = _super.call(this, props) || this;
        _this.first = function () {
            return _this.next(EMPTY_VALUE);
        };
        _this.last = function () {
            var data = _this._data(), item = data[data.length - 1];
            return isDisabledOrReadonly(item, _this.props) ? _this.prev(item) : item;
        };
        _this.prev = function (item, word) {
            var data = _this._data(), nextIdx = data.indexOf(item), matches = matcher_1.matcher(word, item, _this.props.textField);
            if (nextIdx < 0 || nextIdx == null) {
                nextIdx = 0;
            }
            nextIdx--;
            while (nextIdx > -1 && (isDisabledOrReadonly(data[nextIdx], _this.props) || !matches(data[nextIdx]))) {
                nextIdx--;
            }
            return nextIdx >= 0 ? data[nextIdx] : item;
        };
        _this.next = function (item, word) {
            var data = _this._data(), nextIdx = data.indexOf(item) + 1, len = data.length, matches = matcher_1.matcher(word, item, _this.props.textField);
            while (nextIdx < len && (isDisabledOrReadonly(data[nextIdx], _this.props) || !matches(data[nextIdx]))) {
                nextIdx++;
            }
            return nextIdx < len ? data[nextIdx] : item;
        };
        _this._renderGroupHeader = function (group) {
            var GroupComponent = _this.props.groupComponent, id = widget_helpers_1.instanceId(_this);
            return (React.createElement("li", { key: 'item_' + group, tabIndex: -1, role: "separator", id: id + '_group_' + group, className: vdl_prefix_1.vdlPrefix('list__group-header') }, GroupComponent ? React.createElement(GroupComponent, { item: group }) : group));
        };
        _this._renderItem = function (group, item, idx) {
            var _a = _this.props, focused = _a.focused, selected = _a.selected, onSelect = _a.onSelect, textField = _a.textField, valueField = _a.valueField, ItemComponent = _a.itemComponent, ListOption = _a.optionComponent;
            var currentID = idx !== -1 ? optionId(widget_helpers_1.instanceId(_this), idx) : undefined;
            var isDisabled = interaction_1.isDisabledItem(item, _this.props);
            var isReadOnly = interaction_1.isReadOnlyItem(item, _this.props);
            if (focused === item) {
                _this._currentActiveID = currentID;
            }
            return (React.createElement(ListOption, { key: 'item_' + group + '_' + idx, id: currentID, dataItem: item, focused: focused === item, selected: interaction_1.contains(item, selected, valueField), disabled: isDisabled, readOnly: isReadOnly, onClick: isDisabled || isReadOnly ? undefined : onSelect ? onSelect.bind(null, item) : undefined }, ItemComponent ?
                (React.createElement(ItemComponent, { item: item, value: data_helpers_1.dataValue(item, valueField), text: data_helpers_1.dataText(item, textField), disabled: isDisabled, readOnly: isReadOnly }))
                : data_helpers_1.dataText(item, textField)));
        };
        _this._isIndexOf = function (idx, item) {
            return _this.props.data[idx] === item;
        };
        _this._group = function (groupBy, data, keys) {
            var iter = typeof groupBy === 'function' ? groupBy : function (item) { return item[groupBy]; };
            // the keys array ensures that groups are rendered in the order they came in
            // which means that if you sort the data array it will render sorted,
            // so long as you also sorted by group
            keys = keys || [];
            warning_1.default(typeof groupBy !== 'string' || !data.length || _1.has(data[0], groupBy), '[adp-react-components] You are seem to be trying to group this list by a '
                + ("property `" + groupBy + "` that doesn't exist in the dataset items, this may be a typo"));
            return data.reduce(function (grps, item) {
                var group = iter(item);
                if (_1.has(grps, group)) {
                    grps[group].push(item);
                }
                else {
                    keys.push(group), grps[group] = [item];
                }
                return grps;
            }, {});
        };
        _this._data = function () {
            var groups = _this.state.groups;
            return _this.state.sortedKeys
                .reduce(function (flat, grp) { return flat.concat(groups[grp]); }, []);
        };
        _this.move = function () {
            var selected = _this.getItemDOMNode(_this.props.focused);
            if (!selected) {
                return;
            }
            widget_helpers_1.notify(_this.props.onMove, [selected, ReactDOM.findDOMNode(_this), _this.props.focused]);
        };
        _this.getItemDOMNode = function (item) {
            var list = ReactDOM.findDOMNode(_this), groups = _this.state.groups, idx = -1, itemIdx, child;
            _this.state.sortedKeys.some(function (group) {
                itemIdx = groups[group].indexOf(item);
                idx++;
                if (itemIdx !== -1) {
                    return !!(child = list.children[idx + itemIdx + 1]);
                }
                idx += groups[group].length;
                return false;
            });
            return child;
        };
        var keys = [];
        _this.state = {
            groups: _this._group(_this.props.groupBy, _this.props.data, keys),
            sortedKeys: keys
        };
        return _this;
    }
    ListGroupable.prototype.componentDidMount = function () {
        this.move();
    };
    ListGroupable.prototype.componentWillReceiveProps = function (nextProps) {
        var keys = [];
        if (nextProps.data !== this.props.data || nextProps.groupBy !== this.props.groupBy) {
            this.setState({
                groups: this._group(nextProps.groupBy, nextProps.data, keys),
                sortedKeys: keys
            });
        }
    };
    ListGroupable.prototype.componentDidUpdate = function () {
        var onAriaActiveDescendant = this.props.onAriaActiveDescendant;
        this.move();
        if (onAriaActiveDescendant) {
            onAriaActiveDescendant(this._currentActiveID);
        }
    };
    ListGroupable.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, disabled = _a.disabled, readOnly = _a.readOnly, role = _a.role;
        var id = widget_helpers_1.instanceId(this);
        var data = this.props.data;
        var messages = msgs(this.props.messages);
        var sortedKeys = this.state.sortedKeys;
        var groups = this.state.groups;
        var items = [], idx = -1, group;
        this._currentActiveID = undefined;
        if (data.length) {
            items = sortedKeys
                .reduce(function (items, key) {
                group = groups[key];
                items.push(_this._renderGroupHeader(key));
                for (var itemIdx = 0; itemIdx < group.length; itemIdx++) {
                    items.push(_this._renderItem(key, group[itemIdx], ++idx));
                }
                return items;
            }, []);
        }
        else {
            items = (React.createElement(list_option_1.ListOption, { empty: true, role: "note" }, _1.result(messages.emptyList, this.props)));
        }
        var listClasses = (_b = {},
            _b[vdl_prefix_1.vdlPrefix('list')] = true,
            _b[vdl_prefix_1.vdlPrefix('list--grouped')] = true,
            _b[vdl_prefix_1.vdlPrefix('list--disabled')] = disabled === true,
            _b[vdl_prefix_1.vdlPrefix('list--readonly')] = readOnly === true,
            _b);
        var customProps = _1.omit(this.props, Object.keys(ListGroupable.propTypes));
        return (React.createElement("ul", __assign({}, customProps, { ref: "scrollable", id: id, tabIndex: -1, className: classnames_1.classNames(className, listClasses), role: role }), items));
        var _b;
    };
    ListGroupable.propTypes = {
        data: PropTypes.array,
        onSelect: PropTypes.func,
        onMove: PropTypes.func,
        optionComponent: CustomPropTypes.elementType,
        itemComponent: CustomPropTypes.elementType,
        groupComponent: CustomPropTypes.elementType,
        selected: PropTypes.any,
        focused: PropTypes.any,
        valueField: CustomPropTypes.accessor,
        textField: CustomPropTypes.accessor,
        disabled: CustomPropTypes.disabled.acceptsArray,
        readOnly: CustomPropTypes.readOnly.acceptsArray,
        groupBy: CustomPropTypes.accessor,
        messages: PropTypes.shape({
            emptyList: CustomPropTypes.message
        }),
        className: PropTypes.string,
        role: PropTypes.string,
        onAriaActiveDescendant: PropTypes.func
    };
    ListGroupable.defaultProps = {
        data: [],
        optionComponent: list_option_1.ListOption,
        role: 'listbox',
        groupBy: ''
    };
    return ListGroupable;
}(React.Component));
exports.ListGroupable = ListGroupable;
function localizedMessage(messageKey, locale) {
    return localizers_1.message.formatMessage('adp-react-components/list/' + messageKey, undefined, locale);
}
function msgs(msgs, locale) {
    return Object.assign({
        emptyList: localizedMessage('EMPTY_LIST', locale)
    }, msgs);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/list/list-groupable.js
// module id = 203
// module chunks = 0 1 2 3 4 5 6